/* Quantity +/- stepper buttons — PLP + PDP */
jQuery(document).ready(function($) {
  function bofEnhanceQtyStepper($wrapper) {
    if ($wrapper.data('qtyEnhanced')) { return; }
    $wrapper.data('qtyEnhanced', true);
    var $input = $wrapper.find('input[type="number"]');
    if (!$input.length) { return; }
    $input.before('<button type="button" class="qty-step qty-step--minus" aria-label="Decrease quantity">&minus;</button>');
    $input.after('<button type="button" class="qty-step qty-step--plus" aria-label="Increase quantity">+</button>');
  }

  $('.qty-stepper, .pdp-v2__qty-stepper').each(function() {
    bofEnhanceQtyStepper($(this));
  });

  $(document).on('click', '.qty-stepper .qty-step, .pdp-v2__qty-stepper .qty-step', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var $wrapper = $btn.closest('.qty-stepper, .pdp-v2__qty-stepper');
    var $input = $wrapper.find('input[type="number"]');
    if (!$input.length) { return; }
    var min = parseInt($input.attr('min'), 10);
    if (isNaN(min)) { min = 1; }
    var max = $input.attr('max') ? parseInt($input.attr('max'), 10) : Infinity;
    var val = parseInt($input.val(), 10);
    if (isNaN(val)) { val = min; }
    if ($btn.hasClass('qty-step--plus')) {
      val = Math.min(max, val + 1);
    } else {
      val = Math.max(min, val - 1);
    }
    $input.val(val).trigger('change');
  });
});

/* Cart widget (header minicart) — quantity +/- with live update via /cart/change.js */
jQuery(document).ready(function($) {
  function bofFormatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.money_format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    if (key === 'amount_no_decimals') { value = withDelimiters(cents, 0); }
    else if (key === 'amount_with_comma_separator') { value = withDelimiters(cents, 2, '.', ','); }
    else if (key === 'amount_no_decimals_with_comma_separator') { value = withDelimiters(cents, 0, '.', ','); }
    else { value = withDelimiters(cents, 2); }
    return formatString.replace(placeholderRegex, value);
  }

  function bofUpdateMinicartLine(line, qty, $stepper, $num) {
    $stepper.addClass('is-loading');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: line, quantity: qty },
      dataType: 'json',
      success: function(cart) {
        $('.enj-cartcount, .cart-counter').text(cart.item_count);
        $('.minicart .total-price').text(bofFormatMoney(cart.total_price));
        if (qty <= 0) {
          var $item = $stepper.closest('.minicart_item');
          $item.nextAll('.minicart_item').each(function() {
            var $next = $(this);
            var $s = $next.find('.minicart-qty');
            var $r = $next.find('.remove-product');
            var curLine = parseInt($s.attr('data-line'), 10) - 1;
            $s.attr('data-line', curLine).data('line', curLine);
            $r.attr('data-line', curLine).data('line', curLine);
          });
          $item.fadeOut(150, function() {
            $(this).remove();
            if (cart.item_count === 0) { location.reload(); }
          });
        } else {
          $num.text(qty);
          $stepper.removeClass('is-loading');
        }
      },
      error: function() {
        $stepper.removeClass('is-loading');
      }
    });
  }

  $(document).on('click', '.minicart-qty .qty-step', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var $stepper = $btn.closest('.minicart-qty');
    var line = parseInt($stepper.attr('data-line'), 10);
    if (!line) { return; }
    var $num = $stepper.find('.minicart-qty__num');
    var qty = parseInt($num.text(), 10);
    if (isNaN(qty)) { qty = 1; }
    qty = $btn.hasClass('qty-step--plus') ? qty + 1 : qty - 1;
    bofUpdateMinicartLine(line, qty, $stepper, $num);
  });
});
